import { Helmet } from "react-helmet";
import Home from "../components/Home";
import Info from "../components/Info";
import FloatingCircleDev from "../components/dev-tools/FloatingCircle";
import Footer from "../components/Footer";
import Hero from "../components/hero/Hero";
import Menu from "../components/menu/Menu";
import Services from "../components/services/Services";
import {
  getAbsoluteUrl,
  homePageMetadata,
  siteMetadata,
} from "../seo/pageMetadata";
import { getHomeStructuredData, socialImageUrl } from "../seo/schema";

const MainPage = () => {
  const structuredData = getHomeStructuredData();

  return (
    <>
      <Helmet>
        <title>{homePageMetadata.title}</title>
        <meta name="description" content={homePageMetadata.description} />
        <link rel="canonical" href={getAbsoluteUrl(homePageMetadata.path)} />
        <meta property="og:title" content={homePageMetadata.title} />
        <meta property="og:description" content={homePageMetadata.description} />
        <meta property="og:type" content={homePageMetadata.ogType} />
        <meta property="og:url" content={getAbsoluteUrl(homePageMetadata.path)} />
        <meta property="og:site_name" content={siteMetadata.name} />
        <meta property="og:image" content={socialImageUrl} />
        <meta
          property="og:image:width"
          content={String(siteMetadata.socialImageWidth)}
        />
        <meta
          property="og:image:height"
          content={String(siteMetadata.socialImageHeight)}
        />
        <meta property="og:image:alt" content={siteMetadata.socialImageAlt} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={homePageMetadata.title} />
        <meta name="twitter:description" content={homePageMetadata.description} />
        <meta name="twitter:image" content={socialImageUrl} />
        <meta name="twitter:image:alt" content={siteMetadata.socialImageAlt} />
        {structuredData.map((item, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(item)}
          </script>
        ))}
      </Helmet>
      <Menu />
      <Hero />
      <Home />
      <Services />
      <Info />
      <Footer />
      {process.env.REACT_APP_STAGE === "development" && <FloatingCircleDev />}
    </>
  );
};

export default MainPage;
